import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/site/LegalDisplay.js");
